<template>
    <ul class="progress-bar" :class="{ mini: mini }">
        <li v-for="step in progressSteps" >
            <router-link :to="step.link"
                :class="[ step.type, { 'completed': step.isCompleted, 'active': step.isActive }]" >
                <span>{{ step.precedence }}</span>
            </router-link>
        </li>
        <li>
            <router-link :to="doneLink" class="done" :class="{'active': isDoneStepActive}" ></router-link>
        </li>
    </ul>
</template>


<script>
export default {
    components: {},
    props: {
        steps: {},
        progress: {},
        assignment: {},
        mini: {
            type: Boolean,
            default: false,
        },
        autolink: {
            type: Boolean,
            default: false
        },
        currentStep: {
            default: null
        }
    },
    vuex: {
        getters: {},
        actions: {}
    },
    methods: {
        stepLink: function(step) {
            if (this.autolink) return { name: 'assignment', params: { assignmentId: this.assignment.id }}
            return { name: 'assignment.step', params: { assignmentId: this.assignment.id, stepIdx: step.precedence }}
        },
        isStepCompleted: function(step) {
            if ( this.progress == null ) {
                return false
            }
            return this.finished || this.progress.step >= step.precedence
        }
    },
    computed: {
        progressSteps: function() {

            return this.steps.map( s => ({
                link: this.stepLink(s),
                type: s.type,
                isCompleted: this.isStepCompleted(s),
                isActive: this.currentStep == s.precedence,
                precedence: s.precedence,
            }))

        },
        finished: function() {
            return this.progress == null ? false : this.progress.finished
        },
        isDoneStepActive: function() {
            return (typeof this.currentStep === 'string') ? this.currentStep.split('.').some( p => p === 'done' ||  p === 'overview' ) : false
        },
        doneLink: function() {
            if (this.autolink) return { name: 'assignment', params: { assignmentId: this.assignment.id }}
            return { name: (this.finished ? 'assignment.overview' : 'assignment.done'), params: { assignmentId: this.assignment.id  } }
        }
    }
}
</script>


<style lang="scss">

    @import 'global';

    .progress-bar {

        padding: 0;
        margin: 10px 0;

        line-height: 10px;

        @include clearfix();

        li {
            display: inline-block;
            list-style: none;
            padding: 0;
        }

        a {

            display: block;
            position: relative;

            height: $progress-info-height;
            width: $progress-info-width;
            margin: 0 2px;

            text-decoration: none;

            transition: transform 0.1s ease-out;

            @include sprite-image($progress-info-viewed-2x); // only change this to get retina/non-retina
            @include sprite-background-size($progress-info-viewed); // always non-retina

            span {
                height: 0;
                width: 0;
                overflow: hidden;
                display: block;
                position: absolute;
            }

        }

        @each $type, $value in $step-types {
            .#{$type} {
                @include sprite-position(step($value)); // always non-retina
            }
        }

        .completed, .active {

            @each $type, $value in $step-types {
                &.#{$type} {
                    @include sprite-position(step-viewed($value));
                }
            }

        }

        .active {

            transform: translate(0, -4px);

            &:after {
                content: "";
                display: block;

                @include sprite-width($progress-active-info);
                @include sprite-height($progress-active-info);

                position: absolute;
                left: 0;
                top: 10px;

                @include sprite-image($progress-active-info-2x); // only change this to get retina/non-retina
                @include sprite-background-size($progress-active-info); // always non-retina
            }

            @each $type, $value in $step-types {
                &.#{$type} {

                    &:after {
                        @include sprite-position(step-active($value));
                    }

                }
            }

            &.done:after {
                @include sprite-width($progress-done);
            }

        }


        @mixin progress-bar-mini {
            a {
                width: $progress-mini-info-width;
                padding: $progress-mini-info-height 0 0;
                margin: 2px;
            }

            @each $type, $value in $step-types {
                .#{$type} {
                    @include sprite-position(step-mini($value)); // always non-retina
                }
            }

            .completed, .active {

                @each $type, $value in $step-types {
                    &.#{$type} {
                        @include sprite-position(step-mini-viewed($value));
                    }
                }

            }

            .active:after {
                max-width: 100%;
            }
        }

        &.mini {
            @include progress-bar-mini;
            .done {
                display: none;
            }
        }

        @media only screen and (max-width: 700px) {
            @include progress-bar-mini;
        }

        .done {
            width: $progress-done-width;
        }



    }


</style>



// WEBPACK FOOTER //
// ProgressBar.vue?6ca3b5b2